import { jsxs as p, jsx as e } from "react/jsx-runtime";
import { Icon as d } from "@blueprintjs/core";
import { IconNames as s } from "@blueprintjs/icons";
import { formatPercentageString as c } from "@strata/helper-functions";
import "./main.scss";
const S = ({
  bidDecimal: n,
  referentPriceType: t,
  isPending: g = !1
}) => {
  if (g)
    return {
      preSignString: "Pending",
      postSignString: void 0,
      sign: void 0
    };
  if (n === void 0)
    return {
      preSignString: "--",
      postSignString: void 0,
      sign: void 0
    };
  const i = Number(n);
  return n === null || i === -9.9999 ? {
    preSignString: "Contract Rate",
    postSignString: void 0,
    sign: void 0
  } : {
    preSignString: t,
    postSignString: c(Math.abs(i), void 0, 2),
    sign: i >= 0 ? "+" : "-"
  };
}, x = ({ bidDecimal: n, referentPriceType: t, isPending: g }) => {
  const { preSignString: i, postSignString: o, sign: r } = S({
    bidDecimal: n,
    referentPriceType: t,
    isPending: g
  });
  return !i && r ? `${r}${o}` : [i, r, o].filter((a) => a).join(" ");
}, N = ({
  servicingRate: n = void 0,
  referentPriceType: t = void 0,
  isPending: g = void 0
}) => {
  const { preSignString: i, postSignString: o, sign: r } = S({
    bidDecimal: n,
    referentPriceType: t,
    isPending: g
  });
  return /* @__PURE__ */ p("span", { className: "sds_servicing-rate", children: [
    i && /* @__PURE__ */ e("span", { children: i }),
    r && /* @__PURE__ */ e(
      d,
      {
        className: "padding__left--xx-small padding__right--xx-small",
        icon: r === "+" ? s.PLUS : s.MINUS,
        size: 12
      }
    ),
    r && /* @__PURE__ */ e("span", { children: o })
  ] });
};
export {
  N as ServicingRate,
  x as formatRateString
};
//# sourceMappingURL=index.js.map
